import { settings } from './constants';
import { get } from '../shared/services/FetchService';
import EsiGeo from '../../assets/components/fsUtils/EsiGeo';

class Videos {
	constructor() {
		this.liveVideos = [];
		this.featureVideos = [];
		this.allLiveVideosCount = 0;
	}
}

class FsgoVideosServices {
	constructor() {
		this.getVideosProm = {};
	}

	getVideos(regionalIds, isSF){
		let promName = regionalIds || 'zip';
		if (this.getVideosProm[promName]) {
			return this.getVideosProm[promName];
		}

		let queryParams = regionalIds
			? `ids=${regionalIds}&type=${isSF ? settings.REGIONAL_SF : settings.REGIONAL_POST}`
			: `zip=${EsiGeo.zip || ''}&type=${isSF ? settings.NATIONAL_SF : settings.NATIONAL_POST}`;

		this.getVideosProm[promName] = get(`${settings.PROGS_URL}?${queryParams}`,
			json => {
				let result = new Videos();

				result.allLiveVideosCount = json.live.allCount;
				result.regionNames = json.regionNames;
				result.liveVideos = getItemsFromProg(json.live);
				result.featureVideos = getItemsFromProg(json.featured);

				return result;
			},
			() => new Videos());

		return this.getVideosProm[promName];
	}

	isViewAllSeparatorShown(regionNames, isLive) {
		if (!regionNames || regionNames.length === 0) {
			return true;
		}

		if (regionNames.length === 1 && regionNames[0].length < (isLive ? 21 : 27)) {
			return true;
		}

		return false;
	}
}

function getItemsFromProg(prog) {
	if (prog && prog.count > 0) {
		return prog.items || [];
	}

	return [];
}

export default new FsgoVideosServices();



// WEBPACK FOOTER //
// ./react-app-src/fsgo/FsgoVideosService.js